import { render, staticRenderFns } from "./Carga.vue?vue&type=template&id=0f7f29e6&scoped=true"
import script from "./Carga.vue?vue&type=script&lang=js"
export * from "./Carga.vue?vue&type=script&lang=js"
import style0 from "./Carga.vue?vue&type=style&index=0&id=0f7f29e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f29e6",
  null
  
)

export default component.exports